var React = require('react');

function HoneybookLogoMiniInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M29.61 7.612c1.162-.71 1.852-1.998 1.852-3.364C31.462 1.821 29.364 0 25.66 0H14.262v7.866c-4.19-.198-7.286-1.011-9.2-2.075V.001H0V18h5.063v-7.907c3.066 1.116 6.054 1.684 9.2 1.746V18h11.025c5.579 0 8.146-2.376 8.146-5.713 0-2.3-1.579-3.968-3.826-4.673l.002-.002Zm-10.285-4.07 5.299-.01c1.566 0 2.073.58 2.073 1.26 0 1.29-3.03 2.55-7.372 2.89v-4.14Zm8.135 10.313c.488-.285.833-.619.998-.99.447-1.003-.256-2.234-1.379-2.466-.558-.115-1.463-.12-2.715.191-.26.065-.512.13-.763.194-1.212.312-2.393.615-4.28.872v2.804h5.559c.879-.037 1.811-.157 2.58-.605Z","clipRule":"evenodd"}));
}

HoneybookLogoMiniInline.defaultProps = {"width":"34","height":"18","viewBox":"0 0 34 18","role":"img","aria-label":"HoneyBook"};

module.exports = HoneybookLogoMiniInline;

HoneybookLogoMiniInline.default = HoneybookLogoMiniInline;
